/**
 * Author：brand
 * Creation Time：2019-05-11 10:37
 * Email：brandhuang@qq.com
 */
import axios from 'axios'
import {getToken,removeToken} from '@/utils/auth'
import {Message} from 'element-ui'
import router from '@/router/router'

var service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
  withCredentials: true,
  // headers: {"Content-Type": "application/x-www-form-urlencoded"},
})
/**
 * 请求拦截器
 */
service.interceptors.request.use(
config => {
  let xtoken = getToken()
  if (xtoken != null) {
    if (config.params) {
      config.params.token = xtoken
    } else {
      config.params = {}
      config.params.token = xtoken
    }
  }
  return config
}, error => {
  return Promise.reject(error)
}
)

/**
 * 响应拦截器
 */
service.interceptors.response.use(
response => {
  let res = response.data
  let errorCode = ['100001','100002','100003'] // 100001:token为null，100002： token为过期，100003：token为失效
  if(res.code && errorCode.indexOf(res.code) > -1){
    removeToken()
    eventBus.$emit('clearHistoryTimer')
    router.push({
      path:'/login'
    })
    Message({
      message:res.context,
      type: 'error',
    });
  }
  return res
},
err => {
  if (err && err.response) {
    // switch (err.response.status) {
    //   case 400:
    //     err.message = '请求错误(400)';
    //     break;
    //   case 401:
    //     err.message = '未授权，请重新登录(401)';
    //     break;
    //   case 403:
    //     err.message = '拒绝访问(403)';
    //     break;
    //   case 404:
    //     err.message = '请求出错(404)';
    //     break;
    //   case 408:
    //     err.message = '请求超时(408)';
    //     break;
    //   case 500:
    //     err.message = '服务器错误(500)';
    //     break;
    //   case 501:
    //     err.message = '服务未实现(501)';
    //     break;
    //   case 502:
    //     err.message = '网络错误(502)';
    //     break;
    //   case 503:
    //     err.message = '服务不可用(503)';
    //     break;
    //   case 504:
    //     err.message = '网络超时(504)';
    //     break;
    //   case 505:
    //     err.message = 'HTTP版本不受支持(505)';
    //     break;
    //   default:
    //     err.message = `连接出错(${err.response.status})!`;
    // }
  } else {
    err.message = '网络连接异常，请稍后重试！'
  }
  // Message({
  //   message:err.message,
  //   type: 'error',
  // });
  return Promise.reject(err)
}
)

export default service
